import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICommentsService } from "services/CommentsService";
import { IUsersService } from "services/UsersService";
import { ExternalPasswordChangeModel } from "services/api/cplauthapi/CPLAuthAPI";
import { ExternalAccessCommentModel } from "services/classes/ExternalAccessCommentModel";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  Loading: false,
  ActionSuccessful: false,
};

export const externalAccessSlice = createSlice({
  name: "externalAccess",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createExternalAccessComment.pending, (state) => {
        state.Loading = true;
      })
      .addCase(createExternalAccessComment.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(createExternalAccessComment.fulfilled, (state) => {
        state.Loading = false;
        state.ActionSuccessful = true;
      })
      .addCase(externalPasswordChange.pending, (state) => {
        state.Loading = true;
      })
      .addCase(externalPasswordChange.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(externalPasswordChange.fulfilled, (state) => {
        state.Loading = false;
        state.ActionSuccessful = true;
      });
  },
});

export const createExternalAccessComment = createAsyncThunk<
  void,
  { commentModel: ExternalAccessCommentModel },
  { state: RootState }
>("ExternalAccess/CreateExternalAccessComment", async ({ commentModel }) => {
  const commentsService = container.get<ICommentsService>(SERVICE_TYPES.CommentsService);
  await commentsService.createExternalAccessComment(commentModel);
});

export const externalPasswordChange = createAsyncThunk<
  void,
  { passwordModel: ExternalPasswordChangeModel },
  { state: RootState }
>("ExternalAccess/ExternalPasswordChange", async ({ passwordModel }) => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  await usersService.externalPasswordChange(passwordModel);
});

export const selectLoading = (state: RootState) => state.externalAccess.Loading;
export const selectActionSuccessful = (state: RootState) => state.externalAccess.ActionSuccessful;

export default externalAccessSlice.reducer;
